import { BranchPreview } from '@App/../components/pages/BranchPreview';
import { FeatureOverview } from '@App/../components/pages/FeatureOverview';
import { CoreShopEnvironment, RouterEngine } from '@App/Main.types';
import { AccessToMedicationRoutes } from '@App/routes/AccessToMedication';
import { TreatmentNowRoutes } from '@App/routes/TreatmentNow';
import { Config } from '@Config/Config';
import { ExternalController } from '@Config/ExternalController';
import { path, Routes } from '@Config/Routes';
import { Redirect } from '@Ui/../components/atoms/Redirect/Redirect';
import React, { useEffect, useState } from 'react';
import { Route, Routes as RouteSwitch } from 'react-router';
import { BrowserRouter, MemoryRouter, useNavigate } from 'react-router-dom';

import { AppConfigContext } from './AppConfigContext';
import { ExternalControllerContext } from './ExternalControllerContext';

interface Props {
  onStart?: () => void;
}

const InRouter = ({ onStart }: Props) => {
  const [alreadyStarted, setAlreadyStarted] = useState(false);

  const navigate = useNavigate();

  const handleNavigation = url => {
    navigate(url);
  };

  ExternalController.on('navigateTo', handleNavigation);

  useEffect(() => {
    return function cleanup() {
      ExternalController.removeListener('navigateTo', handleNavigation);
    };
  });

  if (!alreadyStarted) {
    onStart?.();
    setAlreadyStarted(true);
  }

  return (
    <RouteSwitch>
      <Route path={path(`${Routes.VIDEO_CONSULTATION}*`)} element={<TreatmentNowRoutes />} />
      <Route path={path(`${Routes.ACCESS_TO_MEDICATION}*`)} element={<AccessToMedicationRoutes />} />
      {Config.coreShopEnvironment != CoreShopEnvironment.Prod && (
        <Route path={path(Routes.FEATURE_OVERVIEW)} element={<FeatureOverview />} />
      )}
      {Config.coreShopEnvironment != CoreShopEnvironment.Prod && (
        <Route path={path(Routes.BRANCH_PREVIEW)} element={<BranchPreview />} />
      )}
      <Route path="*" element={<Redirect to={path(Routes.ACCESS_TO_MEDICATION)} />} />
    </RouteSwitch>
  );
};

const Main = (props: Props): React.ReactElement => {
  let Router: any = BrowserRouter;

  if (Config.routerEngine === RouterEngine.memory) {
    Router = MemoryRouter;
  }

  return (
    <>
      <ExternalControllerContext.Provider value={ExternalController}>
        <AppConfigContext.Provider value={Config}>
          <Router>
            <InRouter {...props} />
          </Router>
        </AppConfigContext.Provider>
      </ExternalControllerContext.Provider>
      {/*
      Needs to be updated manually when the responsive-global.scss is changed
      */}
      <style
        dangerouslySetInnerHTML={{
          __html:
            '@media screen and (min-width:45em){.ods--is-mobile{padding-top:9rem!important}}@media screen and (min-width:64em){.ods--is-mobile{padding-top:inherit!important}}body button.m-ButtonScrollTop{display: flex !important;right: 20px !important;bottom: 20px !important;}\n'
        }}
      />
    </>
  );
};

export default Main;
